import { useRef } from 'react'
import uniqueId from 'lodash.uniqueid'

export function useUniqueId(prefix?: string) {
  return useRef<string>(uniqueId(prefix)).current
}
